module.exports = __webpack_public_path__ + "static/media/nav-contact.29ac4812.svg";